const BLANK_SPACE = ' '
const MAX_INITIAL_VISIBLE = 6
const MAX_FINAL_VISIBLE = 4
const MAX_VISIBLE = 10
const MASK_CHAR = '*'

export const maskBankAccount = (account: string) => {
	let visibleCount = 0
	const totalVisible = account.replace(/\s/g, '').length

	if (totalVisible <= MAX_VISIBLE) {
		return account
	}

	return account
		.split('')
		.map((char) => {
			if (char === BLANK_SPACE) {
				return char
			}
			visibleCount++
			return visibleCount <= MAX_INITIAL_VISIBLE ||
				visibleCount > totalVisible - MAX_FINAL_VISIBLE
				? char
				: MASK_CHAR
		})
		.join('')
}
